import { render } from "./CorporateNavbar.vue?vue&type=template&id=ac65c010&scoped=true"
import script from "./CorporateNavbar.vue?vue&type=script&lang=js"
export * from "./CorporateNavbar.vue?vue&type=script&lang=js"

import "./CorporateNavbar.vue?vue&type=style&index=0&id=ac65c010&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac65c010"]])

export default __exports__